'use strict';

var ChartLengthOfStayViewport = function ChartLengthOfStayViewport(ChartViewport, chartGroups, chartXAxis, chartSimpleBars, chartScales) {
  var chartParams = require('./ParamsViewport');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('lengthOfStay').asViewport();
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, m1Bars, m2Bars, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartLengthOfStayViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsSimpleBars', 'ChartLengthOfStayScaleViewport'];
module.exports = ChartLengthOfStayViewport;